import { filters, FILTER_TYPE } from '../../../constants';
import type { CustomCompanyFilter } from '../filters';

export const generateOtherFilters = (): CustomCompanyFilter[] => [
  {
    id: filters.primaryFlag,
    label: 'Hide secondary listings',
    subLabel: '(e.g. OTC stocks)',
    rule: `["${filters.primaryFlag}", "=", true]`,
    defaultValue: `["${filters.primaryFlag}", "=", true]`,
  },
  {
    id: filters.isFund,
    label: "Include ETF's & Funds",
    type: FILTER_TYPE.TOGGLE,
    defaultValue: `["${filters.isFund}", "=", true]`,
    rule: `["${filters.isFund}", "=", true]`,
  },
  {
    id: filters.analystCount,
    label:
      'Hide companies with low analyst coverage (Please use the "Analyst Count" filter above)',
    type: FILTER_TYPE.TOGGLE,
    defaultValue: `["${filters.analystCount}", ">", 3]`,
    rule: `["${filters.analystCount}", ">", 3]`,
  },
  {
    id: filters.warningType,
    label: 'Only show companies with recent price volatility',
    type: FILTER_TYPE.TOGGLE,
    defaultValue: `["${filters.warningType}", "in", [3, 4]]`,
    rule: `["${filters.warningType}", "in", [3, 4]]`,
  },
  {
    id: filters.currencyDifferentFromExchange,
    label: 'Show companies with currency different to exchange',
    type: FILTER_TYPE.TOGGLE,
    defaultValue: `["${filters.currencyDifferentFromExchange}", "=", true]`,
    rule: `["${filters.currencyDifferentFromExchange}", "=", true]`,
  },
];
